
import { defineComponent, ref, onMounted, computed } from "vue";
import { api } from "@/services/Api";
import { BusinessClient } from "@/models/Order";
import swal from "sweetalert2";
import { useI18n } from "vue-i18n";
import q from "q";
import LazyImage from "v-lazy-image";
import { useRouter } from "vue-router";
import HeaderTitleWithSearch from "@/components/HeaderTitleWithSearch.vue";
import { useStore } from "@/store";

export default defineComponent({
  components: { LazyImage, HeaderTitleWithSearch },
  async setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const rows = ref<BusinessClient[]>([]);
    const searchText = ref("");
    var clubId = computed(() => store.state.clubId);
    const businessClients = computed(() => {
      if (searchText.value.length < 2) {
        return [];
      }
      return rows.value.filter((x) =>
        x.name.toLowerCase().includes(searchText.value.toLowerCase())
      );
    });
    function onSelect(rowId: number) {
      console.log("onSelect - ", rowId);
    }
    function changeSearchText(newValue: string) {
      searchText.value = newValue;
    }
    function onSelectClub(clubId: number) {
      store.commit("setClubId", clubId);
    }
    function back() {
      store.commit("setClubId", 0);
      router.push({ name: "home" });
    }
    onMounted(async () => {
      swal.showLoading();
      const apiPromise = api.ClubVoucherList();
      await q.delay(400);
      const response = await apiPromise;
      if (response.errorMessage) {
        swal.fire({
          icon: "error",
          title: t("error-pop-up.oops"),
          text: response.errorMessage,
        });
        return;
      }
      rows.value = response.data || [];
      swal.close();
    });
    return {
      rows,
      searchText,
      businessClients,
      onSelect,
      changeSearchText,
      onSelectClub,
      clubId,
      back,
    };
  },
});
